<template>
  <div>
    <q-btn
      class="no-margin no-padding"
      small
      flat
      @click="popoverShowing = !popoverShowing"
      v-if="iconValue && iconValue.trim() !== ''"
    >
        <q-icon :name="icon" v-if="template === 'table'"></q-icon>
        <span v-else>{{ iconValue }}</span>
    </q-btn>
    <div>
      <q-popover anchor="bottom left" self="top left" v-model="popoverShowing" v-if="popoverAction">
        <q-list link separator class="q-body-1">
          <q-item @click="handleOpenAction" class="q-body-1">
            <q-item-side :icon="popoverAction.icon" />
            <q-item-main :label="popoverAction.label" />
          </q-item>
          <q-item
            v-clipboard:copy="iconValue"
            v-clipboard:success="handleCopy"
            class="q-body-1"
          >
            <q-item-side icon="content_copy" />
            <q-item-main label="Copy to Clipboard" />
          </q-item>
        </q-list>
      </q-popover>
    </div>
  </div>
</template>
<script>
import { openURL } from 'quasar'

export default {
  name: 'grid-cell-icon',
  data () {
    return {
      popoverShowing: false,
      editOpened: false,
      model: this.$props.value,
      editing: false
    }
  },
  props: {
    column: {
      required: true,
      type: Object
    },
    value: {
      required: true,
      default () {
        return ''
      }
    },
    template: {
      type: String,
      default: () => 'table'
    }
  },
  computed: {
    iconValue () {
      if (this.value !== null && this.value !== undefined) {
        if (Array.isArray(this.value)) {
          return this.value.join(',')
        }
        return this.value
      }
      return ''
    },
    icon () {
      return this.column ? this.column.icon : ''
    },
    popoverAction () {
      if (!this.column) {
        return {}
      }
      switch (this.column.icon) {
        case 'email':
          return {
            label: this.iconValue,
            icon: 'email',
            url: `mailto:${this.iconValue ? this.iconValue.trim() : ''}`
          }
        case 'link':
          return {
            label: this.iconValue,
            icon: 'link',
            url: this.value ? this.iconValue.trim() : ''
          }
        case 'phone':
          return {
            label: `${this.iconValue ? this.iconValue.trim() : ''}`,
            icon: 'phone',
            url: this.iconValue ? this.iconValue.trim() : ''
          }
      }
    }
  },
  methods: {
    handleEditMode () {
      this.popoverShowing = false
      this.$nextTick(() => {
        this.editing = true
      })
    },
    handleSave () {
      this.$q.notify({
        type: 'positive',
        message: 'Saved!'
      })
      this.editing = false
    },
    handleOpenAction () {
      this.popoverShowing = false
      openURL(this.popoverAction.url)
    },
    handleCopy () {
      this.popoverShowing = false
      this.$q.notify({
        type: 'positive',
        message: `Copied to clipboard: ${this.iconValue}`,
        icon: 'content_copy',
        timeout: 3500,
        button: {
          label: 'Close'
        }
      })
    }
  }
}
</script>
